export const ALL_REGION = 'All';

export type UserFormState = {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  roleId: string;
  regionalCode: string;
  isActive: boolean;
};

export function profileToFormRegionalCode(code?: string | null): string {
  return code?.trim() || ALL_REGION;
}

export function emptyUserForm(defaultRegionalCode = ALL_REGION): UserFormState {
  return {
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    roleId: '',
    regionalCode: defaultRegionalCode,
    isActive: true,
  };
}

export type FieldErrors = Partial<Record<keyof UserFormState, string>>;

export type ExistsCheckStatus = 'idle' | 'checking' | 'available' | 'taken';
